"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _api = require("@focaltec-suite/api");
var _core = require("@focaltec-suite/core");
var _commons = require("@focaltec-suite/commons");
var _TypeRuleForm = _interopRequireDefault(require("./TypeRuleForm"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function RuleForm(_ref) {
  var id = _ref.id,
    tenantId = _ref.tenantId,
    _ref$predefined = _ref.predefined,
    predefined = _ref$predefined === void 0 ? false : _ref$predefined,
    icon = _ref.icon,
    getPromise = _ref.getPromise,
    getSubtitle = _ref.getSubtitle;
  var feedbackContext = (0, _react.useContext)(_commons.FeedbackContext);
  var context = (0, _react.useContext)(_core.AppContext);
  var access = context.access;
  var _useValidatedForm = (0, _commons.useValidatedForm)(),
    bind = _useValidatedForm.bind,
    register = _useValidatedForm.register,
    isDirty = _useValidatedForm.isDirty,
    setPristine = _useValidatedForm.setPristine;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    ruleData = _useState2[0],
    setRuleData = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    types = _useState4[0],
    setTypes = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    type = _useState6[0],
    setType = _useState6[1];
  var labels = (0, _react.useMemo)(function () {
    if (!ruleData) return [];
    var rule = ruleData.rule;
    var items = [{
      text: (0, _core.translate)('rules.sat'),
      color: (rule === null || rule === void 0 ? void 0 : rule.enabled_sat) ? 'success' : 'default',
      variant: (rule === null || rule === void 0 ? void 0 : rule.enabled_sat) ? 'filled' : 'outlined'
    }, {
      text: (0, _core.translate)('rules.cryptographic'),
      color: (rule === null || rule === void 0 ? void 0 : rule.enabled_cryptographic) ? 'success' : 'default',
      variant: (rule === null || rule === void 0 ? void 0 : rule.enabled_cryptographic) ? 'filled' : 'outlined'
    }, {
      text: (0, _core.translate)('rules.efos'),
      color: (rule === null || rule === void 0 ? void 0 : rule.enabled_efos) ? 'success' : 'default',
      variant: (rule === null || rule === void 0 ? void 0 : rule.enabled_efos) ? 'filled' : 'outlined'
    }, {
      text: (0, _core.translate)('rules.predefined'),
      color: (rule === null || rule === void 0 ? void 0 : rule.predefined) ? 'success' : 'default',
      variant: (rule === null || rule === void 0 ? void 0 : rule.predefined) ? 'filled' : 'outlined'
    }];
    return items;
  }, [ruleData]);
  var setData = (0, _react.useCallback)(function (ruleData) {
    var _a, _b;
    setRuleData(ruleData);
    setTypes((_b = (_a = ruleData === null || ruleData === void 0 ? void 0 : ruleData.rule) === null || _a === void 0 ? void 0 : _a.types) !== null && _b !== void 0 ? _b : []);
  }, []);
  var onUpdated = (0, _react.useCallback)(function (typeRule) {
    setTypes(function (curr) {
      var newTypes = curr.map(function (el) {
        if (el.type === typeRule.type) {
          return typeRule;
        }
        return el;
      });
      return newTypes;
    });
    setType(undefined);
  }, []);
  var submitPromise = (0, _react.useCallback)(function (request) {
    if (ruleData === null || ruleData === void 0 ? void 0 : ruleData.rule) {
      return (0, _api.updateRule)(tenantId, id, request, {
        access: access
      });
    }
    return (0, _api.createRule)(tenantId, request, {
      access: access
    });
  }, [tenantId, access, id, ruleData]);
  var onSubmit = function onSubmit() {
    feedbackContext.showBackdrop();
    var request = Object.assign(Object.assign({}, bind()), {
      types: types,
      id: id,
      predefined: predefined
    });
    submitPromise(request).then(function (response) {
      setRuleData(function (cur) {
        if (cur) {
          return Object.assign(Object.assign({}, cur), {
            rule: response
          });
        }
        return {
          rule: response
        };
      });
      setTypes(response.types);
      setPristine();
      feedbackContext.showSuccess((0, _core.translate)('rules.updated', response));
    })["catch"](feedbackContext.showError)["finally"](feedbackContext.closeBackdrop);
  };
  var paymentMethodLabel = (0, _react.useCallback)(function (item) {
    return item.rules.filter(function (el) {
      return el.payment_forms.length > 0;
    }).map(function (el) {
      return el.payment_method;
    }).join(', ') || '---';
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_commons.Retrievable, {
    getPromise: getPromise,
    setData: setData,
    builder: function builder() {
      var _a, _b, _c, _d, _e, _f;
      return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        container: true,
        justifyContent: "center",
        alignItems: "center"
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12,
        md: 10,
        lg: 9,
        xl: 7
      }, /*#__PURE__*/_react["default"].createElement(_commons.Surface, {
        title: (0, _core.translate)('rules.single'),
        subtitle: ruleData ? {
          text: getSubtitle(ruleData),
          labels: labels
        } : undefined,
        icon: icon
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12,
        sx: {
          mb: 2
        }
      }, /*#__PURE__*/_react["default"].createElement(_commons.AnySwitch, {
        name: "enabled_sat",
        initialValue: (_b = (_a = ruleData === null || ruleData === void 0 ? void 0 : ruleData.rule) === null || _a === void 0 ? void 0 : _a.enabled_sat) !== null && _b !== void 0 ? _b : true,
        label: (0, _core.translate)('rules.enabled_sat'),
        register: register
      }), /*#__PURE__*/_react["default"].createElement(_commons.AnySwitch, {
        name: "enabled_cryptographic",
        initialValue: (_d = (_c = ruleData === null || ruleData === void 0 ? void 0 : ruleData.rule) === null || _c === void 0 ? void 0 : _c.enabled_cryptographic) !== null && _d !== void 0 ? _d : true,
        label: (0, _core.translate)('rules.enabled_cryptographic'),
        register: register
      }), /*#__PURE__*/_react["default"].createElement(_commons.AnySwitch, {
        name: "enabled_efos",
        initialValue: (_f = (_e = ruleData === null || ruleData === void 0 ? void 0 : ruleData.rule) === null || _e === void 0 ? void 0 : _e.enabled_efos) !== null && _f !== void 0 ? _f : true,
        label: (0, _core.translate)('rules.enabled_efos'),
        register: register
      })), /*#__PURE__*/_react["default"].createElement(_commons.CardSection, {
        title: (0, _core.translate)('rules.rules'),
        variant: "plain"
      }, /*#__PURE__*/_react["default"].createElement(_commons.DataGrid, {
        items: types,
        loading: false,
        getId: function getId(item) {
          return item.type;
        },
        columns: [{
          title: (0, _core.translate)('cfdi.types.title'),
          converter: function converter(item) {
            return (0, _core.translate)("cfdi.types.".concat(item.type));
          },
          id: 'type'
        }, {
          title: (0, _core.translate)('cfdi.methods.title'),
          converter: paymentMethodLabel,
          id: 'payment_methods'
        }, {
          title: (0, _core.translate)('cfdi.uses.title'),
          converter: function converter(item) {
            var _a, _b;
            return (_b = (_a = item.uses) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
          },
          id: 'uses'
        }, {
          title: /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
            size: "small",
            color: "primary",
            sx: {
              visibility: 'hidden'
            }
          }, /*#__PURE__*/_react["default"].createElement(_commons.AddIcon, null)),
          converter: function converter(item) {
            return /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
              size: "small",
              color: "primary",
              onClick: function onClick() {
                return setType(item);
              }
            }, /*#__PURE__*/_react["default"].createElement(_commons.EditIcon, null));
          },
          id: 'actions',
          fixed: 'right',
          width: 60,
          textAlign: 'center'
        }]
      })), /*#__PURE__*/_react["default"].createElement(_commons.FormActions, {
        type: "button",
        mainAction: (0, _core.translate)('buttons.update'),
        onClick: onSubmit
      }), /*#__PURE__*/_react["default"].createElement(_commons.FormPrompt, {
        isDirty: isDirty
      })))), type && /*#__PURE__*/_react["default"].createElement(_TypeRuleForm["default"], {
        data: type,
        onUpdated: onUpdated,
        onClose: function onClose() {
          return setType(undefined);
        }
      }));
    }
  });
}
var _default = exports["default"] = RuleForm;